import { Box, CircularProgress, Typography } from '@mui/material';
import { PrimaryButton, SecondaryButton } from '../../../shared/ui/Inputs.js';
import { Modal } from '../../../shared/ui/Modal';
import { ModalList, PreCheckError } from './spreadsheetUploadConfig.style.js';

export const SendSpreadsheetModal = ({ open, onClose, loading, error, progress, canConfirm, onConfirm }) => {
    const stage = progress?.stage || '';
    const current = Number(progress?.current ?? 0);
    const total = Number(progress?.total ?? 0);
    const showProgress = loading && (stage || total > 0);

    return (
        <Modal open={open} handleClose={onClose} width="600px">
            <Box>
                <Typography variant="h5" style={{ fontWeight: 700, textAlign: 'center' }}>
                    Confirmar envio da planilha
                </Typography>

                <Box style={{ marginTop: 12 }}>
                    <Typography variant="body2" style={{ color: '#6b7280', lineHeight: 1.5 }}>
                        O envio irá processar a planilha e substituir as informações dos produtos. Antes de aplicar a atualização, o sistema salva um
                        snapshot (backup) do estado atual.
                    </Typography>

                    <Box style={{ marginTop: 10 }}>
                        <Typography variant="body2" style={{ lineHeight: 1.5, fontWeight: 700 }}>
                            Avisos
                        </Typography>
                        <ModalList style={{ marginTop: 6 }}>
                            <li>Verifique os dados, colunas e formatação da planilha.</li>
                            <li>Após a atualização, revise os produtos para confirmar que as informações estão corretas.</li>
                            <li>Em caso de erro ou dados incorretos, utilize a função de rollback para restaurar o estado anterior.</li>
                        </ModalList>
                    </Box>

                    {error ? <PreCheckError style={{ marginTop: 10 }}>{error}</PreCheckError> : null}

                    {showProgress ? (
                        <Box
                            style={{
                                marginTop: 12,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                            }}
                        >
                            <CircularProgress size={18} />
                            <Typography variant="body2" style={{ color: '#6b7280' }}>
                                {stage}
                                {total > 0 ? ` ${current}/${total}` : ''}
                            </Typography>
                        </Box>
                    ) : null}
                </Box>

                <Box
                    style={{
                        display: 'flex',
                        gap: 10,
                        justifyContent: 'center',
                        marginTop: 18,
                        flexWrap: 'wrap',
                    }}
                >
                    <SecondaryButton type="button" onClick={onClose} disabled={loading}>
                        Cancelar
                    </SecondaryButton>
                    <PrimaryButton
                        type="button"
                        disabled={!canConfirm || loading}
                        title={loading ? stage || 'Processando…' : 'Confirmar envio'}
                        onClick={onConfirm}
                    >
                        Confirmar
                    </PrimaryButton>
                </Box>
            </Box>
        </Modal>
    );
};
